import createNotificationModel, { prop } from 'models/notification/lib/create_notification_model';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import NotificationType from 'models/notification/notification_type';

export default createNotificationModel(NotificationType.OPTIONAL_UPGRADE, {
  modelName: 'OptionalUpgradeNotification',
  properties: {
    id: prop(String).isRequired,
    isPostponed: Boolean,
  },

  activate() {
    this.isPostponed = false;
  },

  postpone() {
    this.isPostponed = true;
  },

  statics: {
    create(attrs) {
      return new this({ id: IdGenerator.newId(), ...attrs });
    },
  },
});
